/** Keep the previous object when a poll returns the same JSON. */
export function keepIfSameJson<T>(current: T, next: T): T {
	if (
		current !== undefined &&
		next !== undefined &&
		current !== next &&
		JSON.stringify(current) === JSON.stringify(next)
	) {
		return current;
	}
	return next;
}
